var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.6C11.8298 15.6 11.6698 15.57 11.5098 15.51C11.3498 15.45 11.2098 15.36 11.0698 15.22L6.44984 10.6C6.19984 10.37 6.08984 10.07 6.08984 9.70001C6.08984 9.34001 6.22984 9.03001 6.47984 8.78001C6.72984 8.53001 7.03984 8.40001 7.39984 8.40001C7.75984 8.40001 8.06984 8.52001 8.31984 8.78001L11.9998 12.46L15.6998 8.75001C15.9498 8.50001 16.2598 8.39001 16.6198 8.39001C16.9798 8.39001 17.2798 8.53001 17.5298 8.78001C17.7798 9.03001 17.9098 9.34001 17.9098 9.72001C17.9098 10.1 17.7898 10.4 17.5298 10.63L12.9298 15.23C12.7998 15.36 12.6498 15.46 12.4898 15.52C12.3298 15.58 12.1698 15.61 11.9998 15.61V15.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.03b09bd26d632cb88346b9a82bd9040b.svg";
export { ForwardRef as ReactComponent };